<div class="main modal-overlay">
    <div class="modal-container tile-container">
        <div class="modal-header">
            <h2 class="modal-title">New Disinfection Program</h2>
            <button class="close-btn" (click)="onClose()" type="button">
                &times;
            </button>
        </div>
        <div class="modal-body">
            <form
                [formGroup]="disinfectionForm"
                (ngSubmit)="onSubmit()"
                class="add-disinfection-form"
            >
                <!-- Program Name -->
                <div class="form-row mb-3">
                    <div class="form-group program-name-section">
                        <label for="programName"
                            >Program Name<span class="text-danger-required"
                                >*</span
                            ></label
                        >
                        <input
                            type="text"
                            id="programName"
                            class="form-control"
                            formControlName="disinfectionProgramName"
                            placeholder="Enter program name"
                        />
                        <div
                            *ngIf="
                                disinfectionForm.get('disinfectionProgramName')
                                    ?.invalid &&
                                disinfectionForm.get('disinfectionProgramName')
                                    ?.touched
                            "
                            class="text-danger"
                        >
                            Please enter program name.
                        </div>
                    </div>
                </div>

                <!-- Two Column Layout: Disinfection Type | Instructions -->
                <div class="form-row mb-3 two-cols">
                    <!-- Column 1: Disinfection Type -->
                    <div class="form-group disinfection-type-section">
                        <label for="disinfectionType"
                            >Disinfection Type<span class="text-danger-required"
                                >*</span
                            ></label
                        >
                        <select
                            id="disinfectionType"
                            formControlName="disinfectionTypeId"
                            tile-container
                            class="form-control"
                        >
                            <option value="" disabled selected>
                                Please choose disinfection type
                            </option>
                            <option
                                *ngFor="let type of disinfectionlist"
                                [value]="type.id"
                            >
                                {{ type.name }}
                            </option>
                        </select>
                        <div
                            *ngIf="
                                disinfectionForm.get('disinfectionTypeId')
                                    .invalid &&
                                disinfectionForm.get('disinfectionTypeId')
                                    .touched
                            "
                            class="text-danger"
                        >
                            Please select disinfection type.
                        </div>
                    </div>

                    <!-- Column 2: Instructions Section -->
                    <div class="form-group instructions-section">
                        <div class="instructions-header">
                            <label
                                >Instructions<span class="text-danger-required"
                                    >*</span
                                ></label
                            >
                            <button
                                type="button"
                                class="add-instruction-btn"
                                (click)="addInstruction()"
                            >
                                <i class="fas fa-plus"></i> Add Instruction
                            </button>
                        </div>
                        <div
                            formArrayName="instructionsList"
                            class="instructions-container"
                        >
                            <div
                                *ngFor="
                                    let instruction of instructionsList.controls;
                                    let i = index
                                "
                                [formGroupName]="i"
                                class="instruction-item"
                            >
                                <div class="instruction-input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="instructions"
                                        [placeholder]="'Instruction ' + (i + 1)"
                                    />
                                    <button
                                        class="remove-instruction-btn"
                                        type="button"
                                        (click)="removeInstruction(i)"
                                        *ngIf="instructionsList.length > 1"
                                        title="Remove instruction"
                                    >
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                                <div
                                    *ngIf="
                                        instruction.get('instructions')
                                            .invalid &&
                                        instruction.get('instructions').touched
                                    "
                                    class="text-danger"
                                >
                                    Please enter instruction.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="form-actions">
                    <button
                        class="btn close-btn-secondary"
                        type="button"
                        (click)="onClose()"
                    >
                        Close
                    </button>
                    <button
                        class="btn submit-btn"
                        type="submit"
                        [disabled]="isLoading$ | async"
                    >
                        <span class="submit-button-text" *ngIf="!isAuthLoading"
                            >Save Disinfection Program</span
                        >
                        <span class="submit-button-text" *ngIf="isAuthLoading"
                            >Submitting...</span
                        >
                    </button>
                    <img
                        *ngIf="isLoading$ | async"
                        src="assets/img/loader.gif"
                        alt="Loading..."
                        class="loader-image mt-2"
                    />
                </div>
            </form>
        </div>
    </div>
</div>
